import { useAppDispatch, useAppSelector } from "../../../store/store";

export const useSidebarMobile = () => {
    const { mobDrawer } = useAppSelector(state => state.layout)
    const dispatch = useAppDispatch();

    return {
         mobDrawer, dispatch
    }
}